import { choosePreview, previewFromBlocks, type EditorBlock, type PreviewSource } from './blocks';
import { isThreadForm } from './thread';

/**
 * What the composer's preview draws: one post, as the card always has - or a thread, handed over as
 * its blocks for the thread preview to lay out post by post.
 */
export type PreviewModel =
  { kind: 'single'; source: PreviewSource } | { kind: 'thread'; blocks: EditorBlock[] };

/**
 * Which post the preview draws, and as what.
 *
 * WHICH is `choosePreview`'s rule, unchanged: the saved post while it is locked or the form has not
 * been filled from it yet, else the form. AS WHAT is read off the blocks that were CHOSEN, not off
 * the form: a locked thread whose form still holds an unsaved edit that cut it back to one post is
 * drawn as the thread it is saved as, and the other way round.
 */
export function previewModel(a: {
  locked: boolean;
  /** The post the composer was opened on; none for a new post. */
  openedId: string | null | undefined;
  hydratedId: string | null;
  saved: { blocks: EditorBlock[] } | null;
  form: { blocks: EditorBlock[] };
}): PreviewModel {
  const chosen = choosePreview(a);
  return isThreadForm(chosen.blocks)
    ? { kind: 'thread', blocks: chosen.blocks }
    : { kind: 'single', source: previewFromBlocks(chosen.blocks) };
}
